import React from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'

export default class extends React.Component {
    render () {
        var carrierId = this.props.match.params.carrier_id;
        const data = {
            url: `/admin/carriers/carriers/${carrierId}/payments`,
            data: {
                data: [],
                metadata: []
            },
            metadata: [
                {
                    label: 'id',
                    source: 'ATRPAYID',
                    type: 'primary',
                    editable: false,
                    visible: false
                },
                {
                    label: 'Date and Time',
                    source: 'ATRPMNTDATE',
                    type: 'datetime',
                    editable: true,
                    default:  'NOW',
                    placeholder: '1.2.3.4'
                },
                {
                    label: 'Amount',
                    source: 'ATRAMNT',
                    type: 'text',
                    editable: true,
                    default: '0.00',
                    placeholder: '0.00'
                },
                {
                    label: 'Currency',
                    source: 'ATRCURID',
                    type: 'select',
                    editable: true,
                    visible: true,
                    default: '1'
                },
                {
                    label: 'Mode',
                    source: 'mode',
                    type: 'select',
                    editable: true,
                    visible: true,
                    default: '1'
                },
                {
                    label: 'Description',
                    source: 'ATRPMNTDESCR',
                    type: 'text',
                    editable: true,
                    default: '',
                    placeholder: 'description here'
                },
                {
                    label: 'Generate Invoice',
                    source: 'invoice',
                    type: 'checkbox',
                    default: false,
                    editable: true
                }
            ]
        }
        return (
            <Panel title = "Payments">
                <Resource
                    addButtonText = "Add Payment"                    
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}
